@if (season(); as s) {
  <app-section-quick-actions section="season" />

  @if (s.draft) {
    <app-draft-warning />
  }


  <header class="atmos-page__header atmos-season__header">
    <h1 class="atmos-page__title">{{ s.name }}</h1>
    <span class="atmos-season__number">#{{ s.number }}</span>
  </header>

  <!-- Overview / facts -->
  <section class="atmos-card atmos-season__overview">
    <div class="atmos-summary__grid">
      <div class="atmos-card__body atmos-summary__main">
        <div class="atmos-facts">
          <div class="atmos-fact-row">
            <div class="atmos-fact">
              <div class="atmos-fact__label">Year</div>
              <div class="atmos-fact__value">
                <mat-icon class="atmos-fact__icon">event_repeat</mat-icon>
                <span class="atmos-fact__text">{{ s.year }}</span>
              </div>
            </div>
            <div class="atmos-fact atmos-fact--wide">
              <div class="atmos-fact__label">Duration</div>
              <div class="atmos-fact__value atmos-fact__value--wrap">
                <mat-icon class="atmos-fact__icon">calendar_month</mat-icon>
                <span><app-date-range [start]="s.date" [end]="s.endDate"></app-date-range></span>
                <span class="atmos-fact__meta">
                  (<app-duration [start]="s.date" [end]="s.endDate"></app-duration> ·
                  <app-days-left [start]="s.date" [end]="s.endDate"></app-days-left>)
                </span>
              </div>
            </div>
          </div>
          <div class="atmos-fact">
            <div class="atmos-fact__label">Seasonal candles</div>
            <div class="atmos-fact__value">
              <mat-icon svgIcon="season-candle" class="seasonal"></mat-icon>
              <span>{{ sc() }}</span>
              @if (scLeft()) {
                <span class="atmos-fact__meta">({{ scLeft() }} needed)</span>
              }
            </div>
          </div>
          <div class="atmos-fact">
            <div class="atmos-fact__label">Seasonal hearts</div>
            <div class="atmos-fact__value">
              <mat-icon svgIcon="season-heart" class="seasonal"></mat-icon>
              <span>{{ sh() }}</span>
              @if (shLeft()) {
                <span class="atmos-fact__meta">({{ shLeft() }} needed)</span>
              }
            </div>
          </div>
        </div>
        <div class="atmos-season__pass">
          <button type="button" class="atmos-btn atmos-btn--sm"
                  [class.atmos-btn--active]="hasBoughtSeasonPass()"
                  (click)="toggleSeasonPass(false)">
            <mat-icon>{{ hasBoughtSeasonPass() ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            Bought Season Pass
          </button>
          <button type="button" class="atmos-btn atmos-btn--sm"
                  [class.atmos-btn--active]="hasGiftedSeasonPass()"
                  (click)="toggleSeasonPass(true)">
            <mat-icon>{{ hasGiftedSeasonPass() ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            Received Season Pass
          </button>
        </div>
      </div>

      @if (s.imageUrl) {
        <div class="atmos-summary__preview" [style.background-image]="imageStyle()"></div>
      }
    </div>

    @if (previousSeason() || nextSeason() || s._wiki?.href || s._calendar?.href) {
      <div class="atmos-summary__actions">
        @if (previousSeason(); as p) {
          <a class="atmos-summary__action" [routerLink]="['/season', p.guid]">
            <mat-icon>arrow_back</mat-icon> Previous season
          </a>
        }
        @if (nextSeason(); as n) {
          <a class="atmos-summary__action" [routerLink]="['/season', n.guid]">
            <mat-icon>arrow_forward</mat-icon> Next season
          </a>
        }
        @if (s._wiki?.href; as wikiHref) {
          <a class="atmos-summary__action atmos-summary__action--end" [href]="wikiHref" target="_blank" rel="noopener">
            <mat-icon>open_in_new</mat-icon> Wiki
          </a>
        }
        @if (s._calendar?.href; as calendarHref) {
          <a class="atmos-summary__action" [class.atmos-summary__action--end]="!s._wiki?.href"
             [href]="calendarHref" target="_blank" rel="noopener">
            <mat-icon>open_in_new</mat-icon> Sky Event Calendar | FM
          </a>
        }
      </div>
    }
  </section>

  @if (state() === 'ended' && guide() && guideTreePostSeason(); as postTree) {
    <section class="atmos-card atmos-season__section">
      <header class="atmos-season__section-header">
        <h2 class="atmos-section__title atmos-section__title--lg">Post-season guide tree</h2>
      </header>
      <div class="atmos-card__body atmos-spirit-trees">
        <div class="atmos-season__tree">
          <app-spirit-tree [tree]="postTree" [name]="guide()!.name"
            [nameLink]="['/spirit', guide()!.guid]" [nameQueryParams]="{ highlightTree: postTree.guid }"
            [nodeSubIcons]="SUBICONS_NO_SEASON"
            [highlight]="highlightTree() === postTree.guid"></app-spirit-tree>
        </div>
      </div>
    </section>
  }

  <!-- Trees -->
  <section class="atmos-card atmos-season__section">
    <header class="atmos-season__section-header">
      <h2 class="atmos-section__title atmos-section__title--lg">
        {{ state() === 'ended' ? 'Season spirit trees' : 'Spirit trees' }}
      </h2>
    </header>
    <div class="atmos-card__body atmos-spirit-trees">
      @if (guide(); as g) {
        @if (guideTree(); as gt) {
          <div class="atmos-season__tree">
            <app-spirit-tree [tree]="gt" [name]="g.name"
              [nameLink]="['/spirit', g.guid]" [nameQueryParams]="{ highlightTree: gt.guid }"
              nameTag="Guide"
              [nodeSubIcons]="SUBICONS_NO_SEASON"
              [highlight]="highlightTree() === gt.guid"></app-spirit-tree>
          </div>
        }
      }
      @for (entry of seasonTrees(); track entry.spirit.guid) {
        <div class="atmos-season__tree">
          <app-spirit-tree [tree]="entry.tree" [name]="entry.spirit.name"
            [nameLink]="['/spirit', entry.spirit.guid]" [nameQueryParams]="{ highlightTree: entry.tree.guid }"
            [nodeSubIcons]="SUBICONS_NO_SEASON"
            [highlight]="highlightTree() === entry.tree.guid"></app-spirit-tree>
        </div>
      }
    </div>
  </section>

  @if (includedTrees()?.length) {
    <section class="atmos-card atmos-season__section">
      <header class="atmos-season__section-header">
        <h2 class="atmos-section__title atmos-section__title--lg">Related spirit trees</h2>
      </header>
      <div class="atmos-card__body atmos-spirit-trees">
        @for (tree of includedTrees(); track tree.guid) {
          <div class="atmos-season__tree">
            <app-spirit-tree [tree]="tree" [name]="tree.name ?? tree.spirit?.name ?? 'Spirit tree'"
              [nameLink]="tree.spirit ? ['/spirit', tree.spirit.guid] : undefined"></app-spirit-tree>
          </div>
        }
      </div>
    </section>
  }

  @if (shops().length) {
    <section class="atmos-card atmos-season__section">
      <header class="atmos-season__section-header">
        <h2 class="atmos-section__title atmos-section__title--lg">Shops</h2>
      </header>
      <div class="atmos-card__body">
        @for (shop of shops(); track shop.guid) {
          @if (shop.itemList) {
            <app-item-list [itemList]="shop.itemList"></app-item-list>
          }
        }
      </div>
    </section>
  }

  @if (iapShops().length) {
    <section class="atmos-card atmos-season__section">
      <header class="atmos-season__section-header">
        <h2 class="atmos-section__title atmos-section__title--lg">In-App Purchases</h2>
      </header>
      <div class="atmos-card__body">
        <div class="atmos-season__iap-grid">
          @for (shop of iapShops(); track shop.guid) {
            @for (iap of shop.iaps; track iap.guid) {
              <app-iap-card
                [iap]="iap"
                [highlightIap]="highlightIap()"
                (purchasedToggle)="togglePurchased(iap)"
                (giftedToggle)="toggleGifted(iap)"></app-iap-card>
            }
          }
        </div>
      </div>
    </section>
  }
}
